import { ReactComponent as PrintIcon } from '../images/Print.svg'

export default PrintIcon
